import styled from 'styled-components';
import {GRAY3} from '../../../../globalVariables/GlobalVariables';

export const editorSection = styled.div`
    margin-block: 20px;
    color: ${GRAY3};
`;
